export type TAnalyticEvent = 'click'

const _track = (event: TAnalyticEvent, details: string) => {
  setTimeout(() => {
    try {
      // @ts-ignore
      if (userMaven) {
        // @ts-ignore
        usermaven('track', event, details)
      }
    } catch {}
  }, 0)
}

export const useAnalytics = () => {
  return {
    track: _track,
  }
}
